import {AxiosInstance} from "axios";
import AcquisitionChannel from "../model/acquisitionChannel/AcquisitionChannel";

/**
 * Api for acquisition channel.
 */
export default class AcquisitionChannelApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch acquisition channels.
	 * @returns {Promise<AcquisitionChannel[]>} Promise containing all acquisition channels.
	 */
	fetchAcquisitionChannels(): Promise<AcquisitionChannel[]> {
		const url = `/api/web/acquisition_channels`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(AcquisitionChannel.fromJson));
	}

	/**
	 * Create acquisition channel action.
	 */
	createAcquisitionChannel(data: AcquisitionChannel): Promise<AcquisitionChannel> {
		const url = `/api/web/acquisition_channels`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => AcquisitionChannel.fromJson(resp.data));
	}

	/**
	 * Update acquisition channel action.
	 */
	updateAcquisitionChannel(acquisitionChannelId: string, data: AcquisitionChannel): Promise<AcquisitionChannel> {
		const url = `/api/web/acquisition_channels/${acquisitionChannelId}`;
		return this.axiosInstance.put(url, {name: data.name}).then(resp => AcquisitionChannel.fromJson(resp.data));
	}

	/**
	 * Update acquisition channel sort order.
	 * @param {AcquisitionChannel[]} acquisitionChannels
	 * @returns {Promise<AcquisitionChannel[]>}
	 */
	updateSortOrder(acquisitionChannels: AcquisitionChannel[]) {
		const url = `/api/web/acquisition_channels/orders`;
		const acquisitionChannelIds = acquisitionChannels.map(ac => ac.id);
		return this.axiosInstance.put(url, acquisitionChannelIds);
	}
}